import React, { Component } from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import { Form, Tooltip, Modal, Spin } from 'antd';
import { observer } from 'mobx-react';
import Input from '../Input';
// import { text3 } from '../../../constants/classes';
import { Container, Row, RowTitle, RowInputWrapper } from './styled';

const { confirm } = Modal;
const FormItem = Form.Item;

@Form.create()
@observer
class ItemSpecifics extends Component {
  constructor() {
    super();
    this.state = {
      specName: '',
      specValue: '',
      visibleX: null,
      updatingItemId: ''
    };
  }

  setSpecName = e => {
    this.setState({ specName: e.target.value });
  };

  setSpecValue = e => {
    this.setState({ specValue: e.target.value });
  };

  handleMouseOver = idx => {
    this.setState({ visibleX: idx });
  };
  handleMouseOut = () => {
    this.setState({ visibleX: null });
  };

  handleChanges = e => {
    const { form, specificsData, onChange, updateLastEdit, isListingEdit, itemId } = this.props;
    updateLastEdit(null, null);
    e.preventDefault();
    const { value, id } = e.target;
    form.validateFields(err => {
      if (err) {
        console.log(err);
      } else {
        this.setState({ updatingItemId: id });
        onChange(isListingEdit ? id : Number(id), value, isListingEdit ? itemId : '').then(response => {
          console.log(response);
          if (response) {
            const { id, propsToUpdate } = response; // eslint-disable-line no-shadow
            specificsData.forEach(single => {
              if (single.id === id) {
                single.setNewValue(propsToUpdate);
                form.setFieldsValue({ [single.id]: propsToUpdate });
              }
            });
          }
        });
      }
    });
  };

  addSpecific = () => {
    const { updateSpecifics, setSpinner, isListingEdit, itemId } = this.props;
    setSpinner(true);
    const payload = isListingEdit ? {
      key: this.state.specName,
      value: this.state.specValue,
      itemId
    } : {
      key: this.state.specName,
      value: this.state.specValue,
    };
    updateSpecifics(payload).then(() => {
      this.setState({
        specName: '',
        specValue: '',
      });
      setSpinner(false);
    });
  };

  refactoredName = name => {
    switch (name) {
      case 'package_dimensions_height':
        return 'Height';
      case 'package_dimensions_width':
        return 'Width';
      case 'package_dimensions_length':
        return 'Length';
      case 'package_dimensions_weight':
        return 'Weight';
      case 'package_dimensions_size_unit':
        return 'Size Unit';
      case 'package_dimensions_weight_unit':
        return 'Weight Unit';
      default:
        return name;
    }
  };

  renderRow = data => {
    const {
      form,
      formatMessage,
      updateLastEdit,
      propertyWasOptimized,
      renderToolTipButton,
      propertyIsVero,
      renderVeroToolTipButton,
      setSpinner,
      isListingEdit,
      deleteItemSpecific,
      itemId,
      isSpecificUpdating
    } = this.props;
    const { visibleX } = this.state;
    const { id, isEditable, name, value, isMandatory, removeSelf } = data;
    return (
      <Row
        key={`spec-${data.key}-${id}`}
        onMouseEnter={() => this.handleMouseOver(id)}
        onMouseLeave={() => this.handleMouseOut()}
        onFocus={() => { }}
        onBlur={() => { }}
      >
        <RowTitle>
          <Tooltip title={name}>
            <span>{this.refactoredName(name)}</span>
          </Tooltip>
        </RowTitle>
        {!isListingEdit && propertyWasOptimized(data.key, true) && (
          <div
            css={css`
              margin-top: 5px;
            `}
          >
            {renderToolTipButton('top', data.key, true)}
          </div>
        )}
        {propertyIsVero(data.key) && !isListingEdit && (
          <div
            css={css`
              margin-top: 5px;
            `}
          >
            {renderVeroToolTipButton('top', data.key)}
          </div>
        )}
        <Tooltip title={value}>
          <RowInputWrapper>
            <FormItem style={{ marginBottom: 0 }}>
              {form.getFieldDecorator(`${id}`, {
                initialValue: value,
              })(
                <Input
                  style={{ width: '162px' }}
                  placeholder={formatMessage({ id: 'common.naDoesNotApply' })}
                  onBlur={this.handleChanges}
                  onChange={(e, itemid) => updateLastEdit(e, itemid, this.handleChanges)}
                  disabled={!isEditable && !isListingEdit}
                />,
              )}
            </FormItem>
          </RowInputWrapper>
        </Tooltip>
        {isSpecificUpdating && id === this.state.updatingItemId ?
          (
            <div
              css={css`position: relative; top:9px;`}
            >
              <Spin style={{ height: '22.5px' }} />
            </div>
          ):(
            <div
              css={css`
                width: 20px;
              `}
            />
          )
        }
        {!isMandatory && visibleX === id ? (
          <button
            onClick={() =>
              confirm({
                content: `Are you sure you want to delete the "${name}" specific?`,
                onOk: () => {
                  setSpinner(true);
                  isListingEdit ?
                    deleteItemSpecific(id, itemId).then(() => {
                      setSpinner(false);
                    }) :
                    removeSelf().then(() => {
                      setSpinner(false);
                    });
                },
                onCancel() { },
              })
            }
            css={css`
              cursor: pointer;
              top: 9px;
              position: relative;
              background-color: red;
              border-radius: 10px;
              width: 20px;
              color: white;
              text-align: center;
              height: 20px;
              font-size: 20px;
              border: 0;
              outline: 0;
              line-height: 1;
            `}
          >
            x
          </button>
        ) : (
          <div
            css={css`
              width: 20px;
            `}
          />
        )}
      </Row>
    );
  };

  render() {
    const { formatMessage, specificsData } = this.props;
    return (
      <Container style={{width:450}}>
        <RowTitle
          css={css`
            padding-bottom: 36px;
          `}
        >
          {formatMessage({ id: 'common.itemSpecifics' })}
        </RowTitle>
        {specificsData.map(single => (single.name ? this.renderRow(single) : null))}
        <Row>
          <RowInputWrapper>
            <FormItem style={{ marginBottom: 0 }}>
              <Input
                onPressEnter={this.state.specName ? this.addSpecific : null}
                style={{ width: '145px', marginRight: '5px' }}
                defaultValue={this.state.specName}
                value={this.state.specName}
                onChange={this.setSpecName}
              />
            </FormItem>
          </RowInputWrapper>
          <RowInputWrapper>
            <FormItem style={{ marginBottom: 0 }}>
              <Input
                onPressEnter={this.state.specName ? this.addSpecific : null}
                style={{ width: '162px' }}
                defaultValue={this.state.specValue}
                value={this.state.specValue}
                onChange={this.setSpecValue}
              />
            </FormItem>
          </RowInputWrapper>
          <button
            onClick={this.addSpecific}
            disabled={!this.state.specName}
            css={css`
              cursor: ${this.state.specName ? 'pointer' : 'not-allowed'};
              top: 9px;
              position: relative;
              background-color: green;
              border-radius: 10px;
              width: 20px;
              color: white;
              text-align: center;
              height: 20px;
              font-size: 20px;
              border: 0;
              outline: 0;
              line-height: 1;
            `}
          >
            +
          </button>
        </Row>
      </Container>
    );
  }
}

ItemSpecifics.propTypes = {
  formatMessage: PropTypes.func,
  onChange: PropTypes.func,
  form: PropTypes.object,
  specificsData: PropTypes.array,
  updateLastEdit: PropTypes.func,
  isListingEdit: PropTypes.bool
};

export default ItemSpecifics;
